document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('variant-features-wrapper');
  if (!wrapper) return;

  const featureLists = wrapper.querySelectorAll('.variant-features-content');
  if (!featureLists.length) return;

    const showFeatures = (id) => {
    let hasItems = false;
    featureLists.forEach((el) => {
      if (el.dataset.variantId === String(id)) {
        el.style.display = '';
        hasItems = el.querySelectorAll('.trust-bar__item').length > 0;
      } else {
        el.style.display = 'none';
      }
    });
    wrapper.style.display = hasItems ? 'block' : 'none';
  };

  if (window.globalVariantId) {
    showFeatures(window.globalVariantId);
  }

  document.addEventListener('globalVariantIdUpdated', (e) => {
    showFeatures(e.detail.variantId);
  });
});